import { renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7cae2b90")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("button", {
    class: ["checkbox-button", { 'checked': $props.checked }]
  }, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ], 2))
})